const modal = {
  cancelButton: 'Dismiss',
  confirmButton: 'Confirm',
  confirmChange: {
    title: 'Confirm Change',
    body: 'Are you sure you want to make this change?',
    confirmButton: 'Confirm',
    cancelButton: 'Cancel',
    verificationPlaceholder: 'Enter the verification phrase',
  },
};

export default modal;
